import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { TFunction } from 'i18next';
import type { ComponentType } from 'react';
import { type DealPromptContextType, dealPromptContextTypes } from '../../utils/types.ts';
import { DomainsIcon } from '../icons/DomainsIcon.tsx';

export const getSelectorLabel = (t: TFunction): Record<DealPromptContextType, string> => ({
  [dealPromptContextTypes.ALL]: t('All'),
  [dealPromptContextTypes.DOMAINS]: t('Domains'),
  [dealPromptContextTypes.APPS]: t('Apps'),
  [dealPromptContextTypes.AUDIENCE]: t('Audience'),
});

export const selectorIcon: Record<DealPromptContextType, ComponentType<SvgIconProps>> = {
  [dealPromptContextTypes.ALL]: GridViewOutlinedIcon,
  [dealPromptContextTypes.DOMAINS]: DomainsIcon,
  [dealPromptContextTypes.APPS]: WidgetsOutlinedIcon,
  [dealPromptContextTypes.AUDIENCE]: GroupOutlinedIcon,
};
